import { render, staticRenderFns } from "./InspeCcion.vue?vue&type=template&id=020cc2e2&"
import script from "./InspeCcion.vue?vue&type=script&lang=js&"
export * from "./InspeCcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports